<mat-chip-list [selectable]="false">
  <mat-chip
    *ngFor="let chip of chips; trackBy: chipTrackBy"
    [selected]="false"
    (click)="chipClicked(chip.id)"
    >{{ chip.label }}</mat-chip
  >
</mat-chip-list>
